var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Stack } from "native-base";
import { useMemo } from "react";
import Badge from "../atoms/Badge";
import useResponsive from "../util/useResponsive";
const ListHeader = (_a) => {
    var { rightContent, title, badge, variant = "default", size = "xs" } = _a, rest = __rest(_a, ["rightContent", "title", "badge", "variant", "size"]);
    const { isSmallScreen } = useResponsive();
    const variants = useMemo(() => ({
        default: {
            bgColor: "gray.50",
            borderBottomColor: "gray.100",
        },
        inverted: {
            bgColor: "white",
            borderBottomColor: "transparent",
        },
    }), []);
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "baseline", bgColor: variants[variant].bgColor, borderBottomWidth: 1, borderBottomColor: variants[variant].borderBottomColor, borderBottomStyle: "solid", borderTopRadius: "lg", pt: 6, pb: 2, px: 4, minHeight: 14, width: "full" }, rest, { children: [title && (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", space: 2 }, { children: [_jsx(Heading, Object.assign({ size: size, fontWeight: "medium", textTransform: size === "xs" ? "uppercase" : "none" }, { children: title })), typeof badge !== "undefined" && (_jsx(Badge, Object.assign({ hasIndicator: false, size: "sm", variant: isSmallScreen ? "base" : "ghost" }, { children: badge })))] }))), rightContent && (_jsx(Stack, Object.assign({ direction: "row", alignItems: "center", space: 4 }, { children: rightContent })))] })));
};
export default ListHeader;
